import CryptoJS from 'crypto-js';
import { env } from '../../../config/env';

/**
 * The one AES encrypt/decrypt path in this app. Replaces two divergent
 * implementations that used different query params and different keys
 * (Payment.jsx's `p` + the real secret, vs ThailandPayment.js's `data` +
 * a hardcoded literal `'secret'`) — see the plan's §1. Every gateway now
 * returns through the same callback route, so there's only one payload
 * shape to decrypt on the way back, too.
 *
 * This is client-side obfuscation, not a real security boundary — Vite
 * inlines VITE_SECRET_KEY into the bundle same as CRA did. See the plan's
 * §6/§9: replacing this with a backend-issued reference token is a
 * committed Phase 4 deliverable, not deferred indefinitely.
 */
export function encryptPayload(data: unknown): string {
  return CryptoJS.AES.encrypt(
    JSON.stringify(data),
    env.VITE_SECRET_KEY
  ).toString();
}

export function decryptPayload<T>(ciphertext: string): T | null {
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, env.VITE_SECRET_KEY);
    const json = bytes.toString(CryptoJS.enc.Utf8);

    if (!json) return null;

    return JSON.parse(json) as T;
  } catch {
    return null;
  }
}
